import { makeStyles } from "@material-ui/core";
import { h4Medium, h5Medium, h6Medium } from "../../../shared/typography";

export const useStyles = makeStyles({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  container: {
    padding: "32px 48px",
    background: "#fff",
    width: 320,
  },

  header: {
    display: "flex",
    height: 56,
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 30,
    paddingBottom: 20,
    "@media (max-width:940px)": {
      height: 32,
    },
  },

  headerTitles: {
    ...h4Medium,
  },

  closeIcon: {
    padding: 16,
    cursor: "pointer",
  },

  AccountCancelOrderButton: {
    margin: "32px 0 24px 0",
    height: 56,
    background: "#80BB34",
    color: "#FFF",
    ...h5Medium,
    border: "none",
    width: "100%",
    borderRadius: 16,
    cursor: "pointer",
  },

  notNow: {
    ...h6Medium,
    color: "#80BB34",
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
  },

  cancelTrigger: {
    alignItems: "center",
    color: "#f50050",
    cursor: "pointer",
    display: "flex",
    gap: 8,
    ...h6Medium,
    "@media (max-width: 940px)": {
      width: "100%",
      justifyContent: "center",
      padding: "18px 16px",
      borderRadius: 16,
      background: "#FFFFFF",
      border: "none",
      boxSizing: "border-box",
    },
  },
});
